/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_viewer" | "PdpSharedBlurbSupportNumber_viewer" | "consultAnExpert_viewer" | "PdpSharedBlurbTradeRequestAppointment_viewer">;
    readonly " $refType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$data = PdpRespSidebarBlurbs_viewer;
export type PdpRespSidebarBlurbs_viewer$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "consultAnExpert_viewer",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": "isConsultAnExpertDisabled",
              "name": "isEnabledByLocale",
              "args": [
                {
                  "kind": "Literal",
                  "name": "featureName",
                  "value": "DISABLE_CONSULT_AN_EXPERT"
                }
              ],
              "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbTradeRequestAppointment_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '2fca0e2d5388bbb22885fe4cb0b071e0';
export default node;
